import * as Sentry from "@sentry/nuxt";

if (useRuntimeConfig().public.sentry.dsn != "") {
    Sentry.init({

        // Put env production/development
        environment: useRuntimeConfig().public.sentry.env,

        dsn: useRuntimeConfig().public.sentry.dsn,

        integrations: [
            Sentry.replayIntegration(),
            Sentry.piniaIntegration(usePinia()),
        ],
        // Tracing
        // We recommend adjusting this value in production, or using a tracesSampler for finer control.
        tracesSampleRate: 1.0, //  Capture 100% of the transactions

        autoSessionTracking: true,

        // Session Replay
        replaysSessionSampleRate: 0.01, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 0.1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}